<template>
    <div>
      <files-browser v-if="browserType == 'fusion'" :enableAssetMultiSelect="true" :workspaceList="getWorkspacesList" @close="closeModal" @handleFilesBrowse="handleFilesBrowse"></files-browser>
      <div class="common-input-field" :ref="replyContext?'inputReplyField':'mainReplyField'" :class='!replyContext?"input-field-height-check":"reply-threadinput-field-height-check"' style="margin-top:7px;" :style="customStylesTextarea && (customStylesTextarea.increaseHeightOnClick || customStylesTextarea.unsetTextareaMAXHeight)?'max-height:unset':''">  
        <attach-file v-if="openAttachments" v-bind="attachmentData" uniqueId='attachMediaToMessage' :emptyfiles="emptyfiles" :customUploadInfo="uploadPathObj"  :alreadyAttachedFiles="attachedFiles" @openPipOfAttachment="openPipOfAttachment" @attachedFilesList="attachedFilesList" :customizeStyles="customizeStyles" style="height: calc(100% - 120px);
    overflow: auto;"></attach-file>
       <div v-if="showMentions" ref="scrollContainer" class='mentions-wrapper' :style="openAttachments?'bottom:56%':''">
                <div ref="test" v-for="(uItem, index) in filteredDropdown" :key="uItem._id" v-on:click="selectUserToBeMentioned(uItem)" :class="{ focusElement: index === focus }" class="mentions-option">
                    <div v-if="Object.keys(uItem).includes('profile_image') && !['undefined',null].includes(uItem.profile_image) && uItem.profile_image" class='user-name-or-image' style="margin-inline-end: 9px;">
                        <img :src="getProxyConvertedURL(uItem.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                    </div>
                    <div v-else class="user-name-or-image user-name" :style="style(uItem.username)">{{ uItem.username.split("")[0] }}
                    </div> 
                    <div style="display: flex;align-items: center;">{{uItem.username}}</div>
                </div>
        </div>
        <span class="textarea-wrapper-for-annotation" style="position:relative;display: block; padding: 0; margin: 0;">
            <textarea
                v-model="commentText"
                @focus="changeBckClrOfSendBtn('focus')" 
                @keyup.delete="detectBackspace($event)" 
                v-on:keypress="checkForMentions($event)" 
                @keydown='editMessageEnabled?updateMessage($event):sendMessageOrReply($event)' 
                v-on:blur="changeBckClrOfSendBtn('focusout')" :ref="replyContext?'replyMessageArea':'commentArea'" type="text" class="border rounded text-area-with-border text-light w-100 pl-2"
                tabindex="0"
                :placeholder="customStylesTextarea && customStylesTextarea.placeholderName?customStylesTextarea.placeholderName:'Add message...'"
                :class="customStylesTextarea && customStylesTextarea.increaseHeightOnClick?'applyCustomStyles':''"
                >
             </textarea>

            </span>
            <div style="float:inline-start;display:flex;align-items: center;">
                <div v-if="(!editMessageEnabled && (isEnabled('Upload') || getLoggedInUserInfo().user_type != 'Client')) && !(optionsNotRequired && optionsNotRequired.includes('attachment'))" class="nav-item dropdown show">
                  <a v-if="isFileAttachmentEnabled" class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="#eee" class="bi bi-paperclip" viewBox="0 0 16 16">
                        <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z"/>
                        <title>Attach files</title>
                    </svg>
                  </a>
                  <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                    <a v-if="((isEnabled('catalogs-workspace') || isEnabled('bins-workspace')) && getLoggedInUserInfo().user_type != 'Client')" class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick('fusion')">
                        <div style="height:20px;width:20px">
                            <img :src="fusionLogo" style="width:100%;height:100%;position: relative;inset-inline-end :4px;">
                        </div>
                      <span>from fusion</span>
                    </a>
                    <a v-if="isEnabled('Upload')" class="dropdown-item p-2" style="position:relative;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="position: relative;inset-inline-end :4px;" fill="currentColor" class="bi bi-laptop" viewBox="0 0 16 16">
                        <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
                       </svg>
                      <span>from your computer</span>
                      <div style="position: absolute;top: 1%;inset-inline-start:0%;opacity: 0;height:100%;width:100%">
                            <input 
                                style="height:100%;width:100%"
                                type="file"
                                id="file"
                                ref="uploadFile"
                                multiple
                                v-on:click="resetImageUploader()"
                                v-on:change="getSelectedFileDetailsFromBrowse($event)"
                                />
                        </div></a>
                  </div>
                </div>

                <div v-if="!(optionsNotRequired && optionsNotRequired.includes('emoji'))" style="position:relative;" v-click-outside='hideEmojis' class='icon-background-on-hover emojis-wrapper'>
                    <svg @click="showEmojis = !showEmojis" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-emoji-smile-fill" viewBox="0 0 16 16">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"/>
                    </svg>
                    <div v-if="showEmojis" class='emojies-display' :class="customStylesTextarea && customStylesTextarea.increaseHeightOnClick?'increaseTheWidthOfEmojiBar':''">
                        <span @click="sendThumbsUpEmoji('\u{1F60A}')">&#128522;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F602}')">&#128514;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F607}')">&#128519;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F60D}')">&#128525;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F641}')">&#128577;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F44D}')">&#128077;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F44F}')">&#128079;</span>
                        <span @click="sendThumbsUpEmoji('\u{1F64F}')">&#128591;</span>
                        <span @click="sendThumbsUpEmoji('\u{2705}')">&#9989;</span>
                        <span @click="sendThumbsUpEmoji('\u{274C}')">&#10060;</span>
                    </div>
                </div>
                <!-- <div v-if="customStylesTextarea && customStylesTextarea.displayOnlyAttachedFileName" style="display:flex">
                    <div v-for="(filename,index) in attachedFiles" :key="filename._id" :title="filename">
                        <template v-if="index <= 2">{{filename.slug_name?filename.slug_name:filename.file_name}} {{index == attachedFiles.length-1?'':','}}</template>
                        <template v-else>+{{attachedFiles.length - 2}}</template>
                         &nbsp;
                    </div>
                </div> -->

                <div v-if="(isEnabled('Ticket') || isEnabled('Projects')) && checkForVisibility('attach-tasks')" id="DAM-chat-insert_pam" class="nav-item dropdown show" style="inset-inline-start:2%">
                  <a class="nav-item nav-link dropdown-toggle mr-md-2 icon-background-on-hover" href="#" id="bd-versions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="#eee" class="bi bi-plus-lg" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                    </svg>
                  </a>
                  <div class="dropdown-menu dropdown-menu-md-right p-0" aria-labelledby="bd-versions">
                    <a v-if="isEnabled('Ticket')" class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick('tickets')">
                        <div style="height:20px;width:20px">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                <defs/>
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                <g id="bug" sketch:type="MSArtboardGroup">
                                <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                <rect id="Rectangle-36" fill='#03a8cd' sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                </g>
                                </g>
                                </g>
                            </svg>
                        </div>
                        <span>Tickets</span>
                    </a>
                    <a v-if="isEnabled('Projects')"  class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick('tasks')">
                        <div style="height:20px;width:20px">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                <defs/>
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                <g id="bug" sketch:type="MSArtboardGroup">
                                <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                <rect id="Rectangle-36" fill='#008000' sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                </g>
                                </g>
                                </g>
                            </svg>
                        </div>
                        <span>Tasks</span>
                    </a>
                    <a v-if="isEnabled('Projects')" class="dropdown-item p-2 d-flex" v-on:click="openFileBrowseOnClick('issues')">
                        <div style="height:20px;width:20px">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                <defs/>
                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                <g id="bug" sketch:type="MSArtboardGroup">
                                <g id="Bug" sketch:type="MSLayerGroup" transform="translate(1.000000, 1.000000)">
                                <rect id="Rectangle-36" fill='#E5493A' sketch:type="MSShapeGroup" x="0" y="0" width="14" height="14" rx="2"/>
                                <path d="M10,7 C10,8.657 8.657,10 7,10 C5.343,10 4,8.657 4,7 C4,5.343 5.343,4 7,4 C8.657,4 10,5.343 10,7" id="Fill-2" fill="#FFFFFF" sketch:type="MSShapeGroup"/>
                                </g>
                                </g>
                                </g>
                            </svg>
                        </div>
                        <span>Issues</span>
                    </a>
                  </div>
                </div>

            </div>
        
        <div style="float:inline-end">
            <button v-if="!editMessageEnabled" class="btn btn-primary button-styles" @click.stop.prevent="sendMessageOrReply()" :class="replyContext == true?'replay-comment-btn':'main-comment-btn'" style="background:#5a5a5a;border-color:#5a5a5a">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#eee" class="bi bi-send-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89.471-1.178-1.178.471L5.93 9.363l.338.215a.5.5 0 0 1 .154.154l.215.338 7.494-7.494Z"/>
                </svg>
            </button>
            <button v-if="editMessageEnabled" @click.stop.prevent="cancelUpdateMessage()" class="btn btn-outline-secondary" style="line-height: initial;margin-inline-end:10px;">
               Cancel
            </button>
            <button v-if="editMessageEnabled" @click.stop.prevent="updateMessage()" class="btn btn-outline-primary"  style="line-height: initial;">
               Save
            </button>
        </div> 
    </div>
    </div>
</template>

<script>

import { mapGetters} from 'vuex';
import AttachFile from "./Attachments.vue";
import Utils from "../../components.utils.js";
import fileBrowseModel from "../files/filesBrowse.vue";
import Constants from "../../components.constants.js"
// import Editor from '@tinymce/tinymce-vue'

export default {
   name:'Comments',
   props:["replyContext","usersList","emptyAttachmentsData","closeMentions","editMessageEnabled","editMessage","commentDataToEdit","clearMainInputAreaText","channelData","uploadPathObj",
   'customStylesTextarea', 'optionsNotRequired','isFileAttachmentRequired'],
   data(){
       return {
           chatBrowseWorkspaceList:[Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS],
           fusionLogo:Utils.getLogo(),
           commentText:"",
           selectedFilesFromAttachments:null,
           attachedFilesArr:[],
           attachmentUniqueId:null,
           emptyfiles:false,
           customizeStyles:{
               "background": "#22272b",
               "border": "1px solid  #434343"
           },
           openAttachments:false,
           showMentions:false,
           keypressedForMention:'',
           focus: null,
           positionOfDropdown:{"top":0,"left":0},
           stop:false,
           showEmojis:false,
           cursorPosition:0,
           openFileBrowse:false,
           attachedFiles:[],
           browserType:"",
           isFileAttachmentEnabled: true,
       };
   },
   mounted(){
   },
   components:{
       'attach-file':AttachFile,
       "files-browser":fileBrowseModel,
    //    Editor
   },
   computed:{
        getWorkspacesList(){
            return this.chatBrowseWorkspaceList;
        },
        attachmentData(){
            return {selectedFilesFromAttachBrowse:this.selectedFilesFromAttachments}
        },
        filteredDropdown() {
            let assignedUsersList = [];
            if(this.channelData && this.channelData.channel_members_info){
                assignedUsersList = this.channelData.channel_members_info;
            }else if(this.usersList && this.usersList.length){
                assignedUsersList = this.usersList;
            }
            if(this.keypressedForMention.substr(1) != null){
                if (!assignedUsersList.length) {
                    return [];
                }
                    return assignedUsersList.filter((item) => {
                    const username = item.username.toLowerCase();
                    const searchTerm = this.keypressedForMention.substr(1).toLowerCase();
                    return username.includes(searchTerm);
                });
            }else{
                return assignedUsersList;
            }
        },
    ...mapGetters("users", ["getLoggedInUserPrivilege"]),
    },
   watch :{
        commentText(newVal){
            this.$emit("postComment",newVal); 
        },

        'commentDataToEdit.message':function(newVal){
            if(newVal != undefined && newVal != null){
                this.commentText = newVal;
            }
        },
        'commentDataToEdit.comment':function(newVal){
            if(newVal){
                this.commentText = newVal;
            }
        },
        replyContext(newVal, oldVal){
            if(oldVal !=  newVal && newVal == false){
                if(this.$refs["commentArea"]){
                    this.$refs.commentArea.focus();
                }
            }
        },
        attachmentContext(newVal){
            if(newVal != undefined && newVal != null){
                this.attachmentUniqueId = this.attachmentContext;
            }
        },
        emptyAttachmentsData(newVal){
            if(newVal){
                this.openAttachments = false;
                if(this.clearMainInputAreaText){
                    this.commentText = ""; 
                    this.showMentions = false;
                }
                this.selectedFilesFromAttachBrowse = null;
                this.attachedFilesArr = [];
                this.attachedFiles = [];
                this.emptyfiles = true;
            }
        },
        closeMentions(newVal,oldVal){
            console.log("ssssssssssss",newVal,oldVal);
            this.showMentions = false
        }
   },

   methods:{
        checkForVisibility(value){
            if(this.customStylesTextarea && this.customStylesTextarea.disabledActions && this.customStylesTextarea.disabledActions.includes(value)){
                return false;
            }
            return true;
        },
       style(name){
        let style = {
            'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
            'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
        return style
        },
       replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
       getUniqueId(){
        return Utils.getUUID();
       },
       resetImageUploader(){
           this.$refs.uploadFile.value = '';
       },
       getSelectedFileDetailsFromBrowse(){
        this.selectedFilesFromAttachments = this.$refs.uploadFile.files;
        this.browserType = "";
        this.openAttachments = true;
       },
       changeBckClrOfSendBtn(action){
            if(action == "focus"){
                // if(this.customStylesTextarea && this.customStylesTextarea.increaseHeightOnClick){
                //     if(document.getElementsByClassName("applyCustomStyles")[0])document.getElementsByClassName("applyCustomStyles")[0].setAttribute("style", "min-height: 80px")
                // }
                if(this.replyContext == true){
                    if(parent.document.getElementsByClassName("replay-comment-btn")[0])parent.document.getElementsByClassName("replay-comment-btn")[0].setAttribute("style", "background: #2c6d58; border-color:#2c6d58;"); 
                    parent.document.getElementsByClassName("main-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }else{
                    parent.document.getElementsByClassName("main-comment-btn")[0].setAttribute("style", "background: #2c6d58; border-color:#2c6d58;"); 
                    if(parent.document.getElementsByClassName("replay-comment-btn")[0])parent.document.getElementsByClassName("replay-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }
            }else{
                // if(this.customStylesTextarea && this.customStylesTextarea.increaseHeightOnClick){
                //     if(document.getElementsByClassName("applyCustomStyles")[0])document.getElementsByClassName("applyCustomStyles")[0].setAttribute("style", "min-height: 20px")
                // }
                 if(this.replyContext == true && parent.document.getElementsByClassName("replay-comment-btn")[0]){
                    parent.document.getElementsByClassName("replay-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }else{
                    parent.document.getElementsByClassName("main-comment-btn")[0].setAttribute("style", "background: #5a5a5a; border-color:#5a5a5a;"); 
                }          
            }    
       },

       openPipOfAttachment(fileInfo){
        this.$emit("openPipOfSelectedFile",fileInfo)
       },
        closeModal(){
            this.attachedFiles = [];
            this.browserType = '';
            // this.openFileBrowse = false;
        },
        isButtonRequired(name){
            if(!this.buttonRequiredList) return false;
            if(this.buttonRequiredList && Array.isArray(this.buttonRequiredList) && this.buttonRequiredList.length === 0) return false;
            if(this.buttonRequiredList.indexOf(name) > -1) return true;
            return true;
        },
        attachedFilesList(attcahedFilesArray,alreadyAttachedFiles){
            this.attachedFilesArr = [];
            if(alreadyAttachedFiles != undefined && alreadyAttachedFiles.length){
                for(let j = 0; j< alreadyAttachedFiles.length; j++){
                    this.attachedFilesArr.push(alreadyAttachedFiles[j].file_uid);
                }
            }
            if(attcahedFilesArray != undefined && attcahedFilesArray.length){
                for(let i=0; i<attcahedFilesArray.length; i++){
                    this.attachedFilesArr.push(attcahedFilesArray[i].fileUID);
                }
            }
        },
        checkForMentions(e){
            let temp = /[ `!#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
            if(temp.test(e.key) || e.code == 'Space'){
                this.showMentions = false;
                this.keypressedForMention = '';
                return;
            }
            
            if(e.key == '@'){
                if(this.keypressedForMention.startsWith('@')){
                    this.showMentions = false;
                }else{
                    this.showMentions = true;
                    this.keypressedForMention = e.key;
                }
                    this.showMentions = true;
            }
            if(this.keypressedForMention.startsWith('@')){
                if(e.key != '@'){
                    this.keypressedForMention = this.keypressedForMention.concat(e.key);
                }
            }else{
                this.keypressedForMention = '';
                this.showMentions = false;
            }
        },
        getPosition(){
            return {"left":this.positionOfDropdown.left + 'px',"top":this.positionOfDropdown.top + 'px'}
        },
        detectBackspace(){
            let lastWord = this.commentText.split(" ");
            let mentionCharacterCheck = lastWord[lastWord.length - 1].startsWith('@');
            if(mentionCharacterCheck){
                this.keypressedForMention = lastWord[lastWord.length - 1];
            }else{
                this.keypressedForMention = '';
                this.showMentions = false;
            }
        },
        selectUserToBeMentioned(userData){
            let curPos = 0;
            if(this.$refs["commentArea"]){
                curPos = this.$refs["commentArea"].selectionStart;
            }else{
                curPos = this.$refs["replyMessageArea"].selectionStart;
            }
            let text_to_replace = userData.username + " ";
            if(this.keypressedForMention.length == 1 && this.keypressedForMention == '@'){
                this.commentText = this.commentText.slice(0, curPos) + text_to_replace + this.commentText.slice(curPos);
            }else{
                this.commentText = this.commentText.slice(0, curPos - this.keypressedForMention.length) + '@'+text_to_replace + this.commentText.slice(curPos);
            }
            this.keypressedForMention = '';
            this.showMentions = false;
            if(this.$refs["commentArea"]){
                this.$refs.commentArea.focus();
            }else{
                this.$refs["replyMessageArea"].focus();
            }
        },
        sendMessageOrReply(e){
            if(e){
                this.selectElementsThroughKeys(e);
                if(this.stop == true){
                    this.stop = false
                    e.preventDefault();
                    return false;
                }
                if(e && e.shiftKey){
                    return;
                }
                if(e.code == 'ArrowUp' || e.code == 'ArrowDown'){
                    if(this.showMentions){
                        e.preventDefault();
                    }
                }
                if(e && e.key == "Enter"){
                    e.preventDefault();
                    if(parent.document.getElementsByClassName("upload-unInitialized") && parent.document.getElementsByClassName("upload-unInitialized").length){
                        if (confirm(`Upload not initialized, do you want to continue?`)) {
                            //do nothing
                            this.emptyfiles = true;
                        }else{
                            return false;
                        }
                    }
                    if(parent.document.getElementsByClassName("upload-in-progress") && parent.document.getElementsByClassName("upload-in-progress").length){
                        if (confirm(`Upload is still in progress, wait until it's complete.`)) {
                            return false;
                        }else{
                            this.emptyfiles = true;
                            //do nothing
                        }
                    }
                    if(this.showMentions){
                        return;
                    }
                    this.commentText = this.commentText.replace(/^\s+|\s+$/g, '')
                    this.$emit("messageText",this.commentText,this.attachedFilesArr);
                    this.attachedFilesArr = [];
                    this.attachedFiles = [];
                    this.commentText = "";
                    this.emptyfiles = true;
                    this.openAttachments = false;
                    this.selectedFilesFromAttachments = null;
                }
            }else{
                if(parent.document.getElementsByClassName("upload-unInitialized") && parent.document.getElementsByClassName("upload-unInitialized").length){
                    if (confirm(`Upload not initialized, do you want to continue?`)) {
                        //do nothing
                    }else{
                        this.emptyfiles = true;
                        return false;
                    }
                }
                if(parent.document.getElementsByClassName("upload-in-progress") && parent.document.getElementsByClassName("upload-in-progress").length){
                    if (confirm(`Upload is still in progress, wait until it's complete.`)) {
                        this.emptyfiles = true;
                        return false;
                    }else{
                        //do nothing
                    }
                }
                this.commentText = this.commentText.replace(/^\s+|\s+$/g, '')
                this.$emit("messageText",this.commentText,this.attachedFilesArr);
                this.attachedFilesArr = [];
                this.attachedFiles = [];
                this.commentText = "";
                this.emptyfiles = true;
                this.openAttachments = false;
                this.selectedFilesFromAttachments = null;
            }
        },

        sendThumbsUpEmoji(emoji){
            let curPos = 0;
            if(this.$refs["commentArea"]){
                curPos = this.$refs["commentArea"].selectionStart;
            }else{
                curPos = this.$refs["replyMessageArea"].selectionStart;
            }
            this.commentText = this.commentText.slice(0, curPos) + emoji + this.commentText.slice(curPos);
            if(this.$refs["commentArea"]){
                this.$refs.commentArea.focus();
            }else if(this.$refs["replyMessageArea"]){
                this.$refs.replyMessageArea.focus();
            }
            this.showEmojis = false;
        },

        hideEmojis(){
            this.showEmojis = false
        },
        
        handleFilesBrowse(selectedFiles){
            if(this.chatBrowseWorkspaceList.filter(e =>[Constants.WORKSPACE_TICKETS,Constants.WORKSPACE_TASKS,Constants.WORKSPACE_ISSUES].includes(e)).length){
                for(let i= 0 ;i<selectedFiles.length;i++){
                    let urlType = "";
                    if(selectedFiles[i].task_type == 'Task'){
                        urlType = "/explorer/projects/" + selectedFiles[i].project_id + "/tasks/";
                    }else if(selectedFiles[i].task_type == "Issue"){
                        urlType = "/explorer/projects/" + selectedFiles[i].project_id + "/issues/";
                    }else if(selectedFiles[i].task_type == "Ticket"){
                        urlType = "/explorer/ticket/";
                    }
                    let appendUrl = window.location.protocol + '//' + window.location.host + urlType + selectedFiles[i].task_tag;
                    let curPos = 0;
                    if(this.$refs["commentArea"]){
                        curPos = this.$refs["commentArea"].selectionStart;
                    }else{
                        curPos = this.$refs["replyMessageArea"].selectionStart;
                    }
                    this.commentText = this.commentText.slice(0, curPos) + " " +appendUrl + " " + this.commentText.slice(curPos);
                    if(this.$refs["commentArea"]){
                        this.$refs.commentArea.focus();
                    }else if(this.$refs["replyMessageArea"]){
                        this.$refs.replyMessageArea.focus();
                    }
                }
            }else{
                this.attachedFiles = selectedFiles;
                this.openAttachments = true;
            }
                this.browserType = '';
        },

        selectElementsThroughKeys: function(event) {
            switch (event.keyCode) {
                case 38:
                if (this.focus === null) {
                    this.focus = 0;
                } else if (this.focus > 0) {
                    this.focus--;
                    event.preventDefault();
                }
                this.fixScrolling();
                break;
                case 40:
                if (this.focus === null) {
                    this.focus = 0;
                } else if (this.focus < this.usersList.length - 1) {
                    this.focus++;
                    event.preventDefault();
                }
                this.fixScrolling();
                break;
                case 13:
                    if(this.showMentions){
                        this.stop = true;
                        this.selectUserToBeMentioned(this.filteredDropdown[this.focus]);
                        event.preventDefault();
                    }
                break;
            }
            
        },
        openFileBrowseOnClick(browser){
            this.browserType = "fusion";
            if(browser == 'fusion'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_CATALOG,Constants.WORKSPACE_BINS];
            }else if(browser == 'tickets'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_TICKETS];
            }else if(browser == 'tasks'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_TASKS];
            }else if(browser == 'issues'){
                this.chatBrowseWorkspaceList = [Constants.WORKSPACE_ISSUES];
            }
        },
        fixScrolling(){
            const liH = this.$refs.test[this.focus].clientHeight;
            this.$refs.scrollContainer.scrollTop = liH * this.focus;
        },
        updateMessage(e){
            if(e){
                this.selectElementsThroughKeys(e);
                if(this.stop == true){
                    this.stop = false
                    e.preventDefault();
                    return false;
                }
                if(e && e.shiftKey){
                    return;
                }
                if(e.code == 'ArrowUp' || e.code == 'ArrowDown'){
                    if(this.showMentions){
                        e.preventDefault();
                    }
                }
                if(e && e.key == "Enter"){
                    e.preventDefault();
                    if(this.showMentions){
                        return;
                    }
                    this.commentText = this.commentText.replace(/^\s+|\s+$/g, '')
                    this.$emit("editMessageText",this.commentText,this.commentDataToEdit._id);
                    this.commentText = "";
                    this.emptyfiles = true;
                    this.selectedFilesFromAttachments = null;
                }
            }else{
                this.commentText = this.commentText.replace(/^\s+|\s+$/g, '')
                this.$emit("editMessageText",this.commentText,this.commentDataToEdit._id);
                this.commentText = "";
                this.emptyfiles = true;
                this.selectedFilesFromAttachments = null;
            }
        },
        cancelUpdateMessage(){
            this.$emit("cancelEditMessageText");
        },
        
        isEnabled(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
        },

        returnCommentText(){
            return this.commentText;
        },
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserInfo"]),

    },

    created(){
        if(this.commentDataToEdit){
            if(this.commentDataToEdit.message)this.commentText = this.commentDataToEdit.message;
            if(this.commentDataToEdit.comment)this.commentText = this.commentDataToEdit.comment;
            this.$nextTick(()=>{
                if(this.$refs["replyMessageArea"])this.$refs["replyMessageArea"].focus();
            });
        }
        if(!this.replyContext){
            this.$nextTick(()=>{
                if(this.$refs["commentArea"])this.$refs["commentArea"].focus();
            });
        }
        if(this.closeMentions){
            this.showMentions = false;
        }
        this.attachmentUniqueId = this.attachmentContext;
        if(this.isFileAttachmentRequired != null || this.isFileAttachmentRequired != undefined ){
             this.isFileAttachmentEnabled = this.isFileAttachmentRequired;
        }
    },
}
</script>

<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;

.reply-threadinput-field-height-check{
    max-height: 100% !important;
}

.emojies-display{
    position: absolute;
    display: flex;
    border: $border-color;
    padding: 6px;
    top: -81px;
    inset-inline-start:15px;
    background: #1f2327;
    padding: 6px;
    border-radius: 4px;
    width: 215px;
    justify-content: center;
    flex-wrap: wrap;
    z-index:9;
    span{
        padding: 5px 7px;
        border-radius: 4px;
        font-size:20px;
    }
}

.emojies-display span:hover{
    background: #fdfeff54;
}


.focusElement{
    background: #333;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
}

.user-name{
    margin-inline-end: 10px;
    position: relative;
    bottom: 7px;
}

.icon-background-on-hover:hover{
  background: #fdfeff54 !important;
  padding: 4px;
  height: 28px;
  width: 28px;
  border-radius: 4px !important;
  margin-inline-end:5px;
}

.icon-background-on-hover{
  background: #d1d2d31a;
  padding: 4px;
  height: 28px;
  width: 28px;
  border-radius: 4px;
  margin-inline-end:5px;
}

.text-area-with-border{
    max-height:200px;
    min-height: 80px;
    padding: 4px; 
}
.remove-border{
    max-height:200px;
    min-height: 80px;
    padding: 4px; 
    border: none !important;
    background:transparent;
} 
.remove-border:focus{
    outline: none !important;
    box-shadow: none;
}
.common-input-field{
    display: inline-block;
    width: 100%;
    justify-content: space-between;
    padding: 5px;
    border-radius: 4px;
    background: $primary-background !important;
    border: $secondary-border-color !important;
    max-height:70%;
    position: relative;
    label{
        width: 30%;
        color: $dull-text-color;
        word-break: break-word;
    }
    input{
        flex:1;
    }
}

.input-fields,.mx-datepicker, textarea{
    border-radius: 3px !important;
    border: $border-color !important;
    height: 38px;
    background: $primary-background;
}

textarea:focus{
  outline: none;
  bottom: 0px;
  inset-inline-start:0px;
  --saf-0: rgba(var(--sk_highlight,18,100,163),1);
  box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
  border-radius: 4px;
  border-color: transparent;
  -webkit-appearance: none;
}

.button-styles{
  height: 30px;
  width: auto;
  font-size: 14px;
  svg{
      position: relative;
      bottom: 3px;
  }
}

.mentions-wrapper{
    position: absolute;
    border: $border-color;
    background: $secondary-background-color;
    max-height: 200px;
    min-width:200px;
    overflow: auto;
    z-index: 9999;
    border-radius: 5px;
    width: 99%;
    bottom: 96%;
    .mentions-option{
        text-align: start;
        padding: 5px;
        display:flex;
    }
    .mentions-option:hover{
        background: #333;
    }
}

#DAM-chat-insert_pam{
    .dropdown-menu{
        position:absolute;
        top:-8px !important;
        inset-inline-start:10px !important;
    }
}

.applyCustomStyles{
    min-height: 80px;
}

.increaseTheWidthOfEmojiBar{
    width: 300px;
    top: -20px
}
</style>